import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';
import { NavLink } from 'react-router-dom';

import ArrowMenuDrop from '../../img/icons/ArrowMenuDrop';
import { AppDataContext } from '../../context';
import LanguageSwitcher from '../LanguageSwitcher';

import './index.scss';
import messages from './messages';

import menuImg from '../../img/header/menu.svg';
import logo2Img from '../../img/header/legatum_logo_2.svg';
import userRoundImg from '../../img/header/user-round.svg';
import eclipse101Img from '../../img/header/ellipse-10-1.svg';

const Header = ({ hideLogin }: { hideLogin?: boolean }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false);
  const [mobileAboutOpen, setMobileAboutOpen] = useState<boolean>(false);
  const [mobileUserMenuOpen, setMobileUserMenuOpen] = useState<boolean>(false);
  const navRef = useRef<HTMLDivElement>(null);
  const [submenuOverlayVisible, setSubmenuOverlayVisible] = useState<boolean>(false);

  const intl = useIntl();
  const { authenticatedUser } = useContext(AppDataContext);

  useEffect(() => {
    const adjustNavbar = () => {
      if (navRef.current) {
        if (window.pageYOffset > 0) {
          navRef.current.classList.add('scrolled');
        } else {
          navRef.current.classList.remove('scrolled');
        }
      }
    };

    window.addEventListener('scroll', adjustNavbar);
    adjustNavbar();

    return () => {
      window.removeEventListener('scroll', adjustNavbar);
    };
  }, []);

  // TODO: determine the need for this functionality and prepare new data in the API
  // useEffect(() => {
  //   const navigate = useNavigate();
  //   const navigateToCourse = localStorage.getItem('navigateToCourse');
  //   const firstOfAllowedCourseId = allowedCourses[0]?.course_id;
  //   if (authenticatedUser && !navigateToCourse) {
  //     const currentCourse = firstOfAllowedCourseId;
  //     localStorage.setItem('navigateToCourse', 'false');
  //     navigate(`/course-overview/${currentCourse}`);
  //   }
  // }, [authenticatedUser]);

  const aboutDropDownRef = useRef<HTMLDivElement | null>(null);
  const dashboardDropDownRef = useRef<HTMLDivElement | null>(null);

  const handleMouseEnter = (ref: React.RefObject<HTMLDivElement>) => {
    if (ref.current) {
      ref.current.classList.add('active');
      setSubmenuOverlayVisible(true);
    }
  };

  const handleMouseLeave = (ref: React.RefObject<HTMLDivElement>) => {
    if (ref.current) {
      ref.current.classList.remove('active');
      setSubmenuOverlayVisible(false);
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    if (navRef.current) {
      navRef.current.classList.toggle('mobile-nav-custom');
    }
  };

  const toggleMobileAbout = (e: React.MouseEvent) => {
    e.stopPropagation();
    setMobileAboutOpen(!mobileAboutOpen);
    setMobileUserMenuOpen(false);
  };

  const toggleMobileUserMenu = (e: React.MouseEvent) => {
    e.stopPropagation();
    setMobileUserMenuOpen((prev) => !prev);
    setMobileAboutOpen(false);
  };

  const handleCloseMenus = () => {
    if (mobileMenuOpen) {
      [setMobileMenuOpen, setMobileAboutOpen, setMobileUserMenuOpen].forEach(fn => fn(false));
    }
  };

  return (
    <>
      <div
        className={`nav ${mobileMenuOpen ? 'mobile-nav-custom' : ''}`}
        ref={navRef}
      >
        <div className="nav-cont">
          <NavLink to="/">
            <img
              className="legatum-header-logo"
              src={logo2Img}
              alt={intl.formatMessage(messages.logoAlt)}
            />{' '}
          </NavLink>
          <div className="navbar instrumentsans-normal-white-22-7px">
            <div
              className="navbar-link-courses navbar-link w-dropdown"
              data-name="about"
              onMouseEnter={() => handleMouseEnter(aboutDropDownRef)}
              onMouseLeave={() => handleMouseLeave(aboutDropDownRef)}
            >
              <NavLink to="#">
                {intl.formatMessage(messages.about)}{' '}
                <ArrowMenuDrop />
              </NavLink>
              <div
                className="drop-down about-dd"
                data-name="about"
                ref={aboutDropDownRef}
              >
                <NavLink to="/about" />
                <div className="about-drop">
                  <NavLink to="/about">
                    <span> </span>
                  </NavLink>
                  <NavLink to="/course-overview">{intl.formatMessage(messages.overview)}</NavLink>
                  <span>
                    {' '}
                    <NavLink to="/brought-to-you-by">{intl.formatMessage(messages.broughtToYouBy)}</NavLink>
                  </span>
                  <span>
                    {' '}
                    <NavLink to="/presented-by">{intl.formatMessage(messages.presentedBy)}</NavLink>
                  </span>
                </div>
              </div>
            </div>
            <NavLink to="/course-catalogue">
              <div className="navbar-link-about navbar-link">{intl.formatMessage(messages.modules)}</div>
            </NavLink>
            <NavLink to="/faq">
              <div className="navbar-link-about navbar-link">{intl.formatMessage(messages.faq)}</div>
            </NavLink>
            <NavLink to="/contact">
              <div className="navbar-link-about navbar-link">{intl.formatMessage(messages.contact)}</div>
            </NavLink>
            {!hideLogin && (
              !authenticatedUser ? (
                <NavLink to={`/login?redirect-to=${window.location.href}`}>
                  <div className="navbar-link-about navbar-link">{intl.formatMessage(messages.login)}</div>
                </NavLink>
              ) : (
                <div
                  className="navbar-link w-dropdown logged-in"
                  data-name="user-menu"
                  style={{ display: 'block' }}
                  onMouseEnter={() => handleMouseEnter(dashboardDropDownRef)}
                  onMouseLeave={() => handleMouseLeave(dashboardDropDownRef)}
                >
                  <div className="not-logged-in-user-container">
                    <div className="not-logged-in-user-block">
                      <img src={userRoundImg} alt="" />
                    </div>
                  </div>
                  <div
                    className="drop-down contact-dd user-menu-dd"
                    data-name="user-menu"
                    ref={dashboardDropDownRef}
                  >
                    <div className="about-drop">
                      <span>
                        {' '}
                        <NavLink to="/profile-learner">{intl.formatMessage(messages.profile)}</NavLink>
                      </span>
                      <span>
                        {' '}
                        <NavLink to="/user-dashboard">{intl.formatMessage(messages.dashboard)}</NavLink>
                      </span>
                      <span>
                        {' '}
                        <NavLink
                          to="/logout"
                          className="logout_btn"
                        >
                          {intl.formatMessage(messages.logout)}
                        </NavLink>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            {!authenticatedUser && (
              <LanguageSwitcher
                isMobile={false}
                handleCloseMenus={handleCloseMenus}
                setSubmenuOverlayVisible={setSubmenuOverlayVisible}
              />
            )}
          </div>
          <div className="mobile_toggle navbar-link">
            <div className="mobile_toggle-wrapper">
              <button type="button" onClick={toggleMobileMenu} className="mobile_toggle-button">
                <img alt="Hamburger Menu" src={menuImg} />
              </button>
              {!authenticatedUser && (
                <LanguageSwitcher
                  isMobile
                  handleCloseMenus={handleCloseMenus}
                  setSubmenuOverlayVisible={setSubmenuOverlayVisible}
                />
              )}
            </div>
            <div
              className={`mobile_menu ${mobileMenuOpen ? 'active' : ''}`}
              style={{ height: 'auto' }}
            >
              <div className="navbar-link-courses navbar-link w-dropdown">
                {/* eslint-disable-next-line */}
                <div onClick={toggleMobileAbout}>
                  {intl.formatMessage(messages.about)}{' '}
                  <ArrowMenuDrop />
                </div>
                <div
                  className={`drop-down about-dd ${mobileAboutOpen ? 'active' : ''}`}
                  data-name="about"
                >
                  <div className="about-drop">
                    <NavLink to="/course-overview">{intl.formatMessage(messages.overview)}</NavLink>
                    <NavLink to="/brought-to-you-by">{intl.formatMessage(messages.broughtToYouBy)}</NavLink>
                    <NavLink to="/presented-by">{intl.formatMessage(messages.presentedBy)}</NavLink>
                  </div>
                </div>
              </div>
              <NavLink to="/course-catalogue">
                <div className="navbar-link-about navbar-link">{intl.formatMessage(messages.modules)}</div>
              </NavLink>
              <NavLink to="/faq">
                <div className="navbar-link-about navbar-link">{intl.formatMessage(messages.faq)}</div>
              </NavLink>
              <NavLink to="/contact">
                <div className="navbar-link-about navbar-link">{intl.formatMessage(messages.contact)}</div>
              </NavLink>
              {!authenticatedUser && (
                <NavLink to={`/login?redirect-to=${window.location.href}`}>
                  <div className="navbar-link-about navbar-link">{intl.formatMessage(messages.login)}</div>
                </NavLink>
              )}
              {authenticatedUser && (
                <div // eslint-disable-line
                  className="overlap-group1-1 navbar-link w-dropdown"
                  data-name="user-menu"
                  onClick={(e: React.MouseEvent) => toggleMobileUserMenu(e)}
                >
                  <div className="ellipse-container">
                    <img
                      className="ellipse-10"
                      src={eclipse101Img}
                      alt=""
                    />
                    <div className="ellipse-11" />
                  </div>
                  <div className="ellipse-12" />
                  <div
                    className={`drop-down contact-dd user-menu-dd ${mobileUserMenuOpen ? 'active' : ''}`}
                    data-name="user-menu"
                  >
                    <div className="about-drop">
                      <NavLink to="/profile-learner">{intl.formatMessage(messages.profile)}</NavLink>
                      <NavLink to="/user-dashboard">{intl.formatMessage(messages.dashboard)}</NavLink>
                      <NavLink
                        to="/logout"
                        className="logout_btn"
                      >
                        {intl.formatMessage(messages.logout)}
                      </NavLink>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {submenuOverlayVisible && (
        <div className="header-submenu-overlay" />
      )}
    </>
  );
};

export default Header;
